var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"value":_vm.valueAsObject,"options":_vm.optionsAsArray,"label":"label","track-by":"id","multiple":_vm.multiple,"searchable":_vm.searchable,"show-labels":false,"allow-empty":false,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":function($event){return _vm.inputValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }